export default {
  bind(el, binding, vnode) {
    el.oninput = function(e) {
      if (!e.isTrusted) return;

      let value = e.target.value;
      value = value.replace(/\D/g, "");
      value = value.replace(/(\d)(\d{2})$/, "$1,$2");
      value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");

      e.target.value = value;
      vnode.componentInstance.$emit("input", value);
    };
  },
  componentUpdated(el, binding, vnode) {
    let originalValue = el.value;
    let formattedValue = originalValue.replace(/\D/g, "");
    formattedValue = formattedValue.replace(/(\d)(\d{2})$/, "$1,$2");
    formattedValue = formattedValue.replace(/(?=(\d{3})+(\D))\B/g, ".");

    if (originalValue !== formattedValue) {
      el.value = formattedValue;
      vnode.componentInstance.$emit("input", formattedValue);
    }
  }
};
